import { GetterTree } from 'vuex';
import { RootState } from '@/store/index';
import { AuthenticationState } from '@/store/modules/authentication';
import {
  AUTH_ERRORS,
  AUTH_LOADING_MODE,
  GOV,
  IS_RECAPTCHA_V2_USED,
  LAST_SSO_USED_TOKEN,
  OIDC_ID,
  OIDC_USER_MANAGER,
  OTP_SENT,
  SELECT_AUTH_METHOD_ERRORS,
  SMS_SENDING,
  USER_DETAILS,
} from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { SmsSendingStatus } from '@/models/SmsSendingStatus';
import { INDEX_AND_OFFICES_LIST, UPLOAD_FILE_ENABLE } from '@/types/lobby.types';
import { IndexAndOfficesRequest } from '@/models/request/index-and-offices-request';
import { OidcUserManager } from '@/models/OidcUserManager.model';

export const getters: GetterTree<AuthenticationState, RootState> = {

  [AUTH_LOADING_MODE](state): boolean {
    return state.authLoadingMode;
  },

  [AUTH_ERRORS](state): string[] {
    return state.authErrors;
  },

  [GOV](state): string {
    return state.gov;
  },

  [OTP_SENT](state): boolean {
    return state.otpSent;
  },

  [SMS_SENDING](state): SmsSendingStatus {
    return state.smsSending;
  },

  [USER_DETAILS](state): UserDetails | null {
    return state.userDetails;
  },

  [SELECT_AUTH_METHOD_ERRORS](state): string[] {
    return state.selectAuthMethodErrors;
  },

  [LAST_SSO_USED_TOKEN](state): string {
    return state.lastSsoUsedToken;
  },

  [IS_RECAPTCHA_V2_USED](state): boolean {
    return state.isRecaptchaV2Used;
  },

  [INDEX_AND_OFFICES_LIST](state): IndexAndOfficesRequest[] {
    return state.indexAndOfficesList;
  },

  [UPLOAD_FILE_ENABLE](state): boolean {
    return state.uploadFileEnable;
  },

  [OIDC_ID](state): string | null {
    return state.oidcId;
  },

  [OIDC_USER_MANAGER](state): OidcUserManager | null {
    return state.oidcUserManager;
  },

};
